import { AuthorityLevels } from '@/enums';
import { Client, Material, Truck, User, Vendor } from '@/types/app';
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';

export const emptyValues = Object.freeze({
  date: firebase.firestore.Timestamp.now(),
  geoPoint: new firebase.firestore.GeoPoint(0, 0),
  material: {
    id: '',
    name: ''
  } as Material,
  vendor: {
    location: {
      address: '',
      geoPoint: new firebase.firestore.GeoPoint(0, 0)
    },
    materials: [],
    name: '',
    phone: '',
    doApplyMarkup: true,
    enabled: false
  } as Vendor,
  truck: {
    name: '',
    runRate: 0,
    unloadLoadTime: 0,
    enabled: false
  } as Truck,
  user: {
    authorityLevel: AuthorityLevels.User,
    email: '',
    name: ''
  } as User,
  client: {
    email: '',
    name: '',
    phone: '',
    taxExempt: false
  } as Client
});
